import * as api from './api'
import { setUser } from '@doordash/lib-monitoring'
import { makeActions, makeAsyncActions } from '@doordash/lib-redux-utilities'
import {
  identifyDasher,
  trackCreateConsumerAccountFailure,
  trackCreateDasherAccountError,
  trackDasherApplyNonMarket,
  trackDasherApplySubmissionFailure,
  trackDasherApplySubmissionSuccess,
  trackDasherReturnToApplicationFailure,
  trackDasherReturnToApplicationSuccess,
  trackDeliveryIssuesWithoutId,
  trackDropshippingEvent,
  trackFastPaySetup,
  trackGESubmissionFailureInvalidZip,
  trackGetDeliveryIssuesListError,
  trackLoadDasherApplicationFailure,
  trackOrientationBookingError,
  trackPaymentAccount,
  trackSignupAndSubmitProfileFailure,
  trackSubmitBackgroundCheckError,
  trackSubmitProfileFailure,
  trackUpdateDasherApplicantFailure,
} from './events'
import * as Types from './models/actionTypes'
import {
  AlreadyStartedSigningUpModal,
  DeliveryIssueStatus,
  VehiclePatchData,
} from './models/types'
import * as DA from './typeModules/events'
import { get, isEmpty } from 'lodash'
import { createStandardAction } from 'typesafe-actions'
import {
  NON_MARKET_ERROR,
  REDCARD_POLL_INTERVAL,
  TIMEOUT_TRIES,
} from './constants'
import { camelCaseObjectKeys } from '@doordash/object-utils'
import { processStatePayloadForStripe } from './utilities/processStatePayloadForStripe'
import SimpleStore from './utilities/SimpleStore'
import { IDVStatus } from './utilities/steps'
import { getUtmSource } from './utilities/utmSource'
import { getUrlVars } from './utilities/window'
import { disableHeader, enableHeader } from './webview'
import t from './components/organisms/background-check/strings'

declare const window

export const {
  SUBMIT_DASHER_APPLICATION,
  FIND_DASHER_APPLICATION,
  LOAD_DASHER_APPLICATION,
  LOGIN_DASHER_APPLICATION,
  LOAD_CONSUMER_APPLICATION,
  CREATE_CONSUMER_ACCOUNT,
  UPDATE_DASHER_APPLICANT,
  SUBMIT_PERSONAL_INFO,
  SUBMIT_BACKGROUND_CHECK,
  CREATE_DASHER_ACCOUNT,
  GO_TO_W9,
  SUBMIT_MAILING_ADDRESS,
  SET_DROPSHIPPING,
  BOOK_ORIENTATION,
  CLEAR_ORIENTATION,
  LOAD_ORIENTATIONS,
  GET_APPLICATION_STATUS,
  ACTIVATE_REDCARD,
  GET_STRIPE_CREDENTIALS,
  GET_PAYMENT_ACCOUNT,
  UPDATE_BANK_ACCOUNT,
  CREATE_PAYMENT_ACCOUNT,
  PATCH_PAYMENT_ACCOUNT,
  UPLOAD_PHOTO,
  GET_EXPERIMENT,
  LOAD_WEBVIEW_EXPERIMENTS,
  LOAD_DASHER,
  LOAD_DASHER_ID,
  LOAD_DASHER_REWARD,
  LOAD_WEBVIEW_EXPERIENCE,
  GET_DELIVERY_ISSUES_LIST,
  GET_DELIVERY_ISSUE_DETAILS,
  SUBMIT_DELIVERY_ISSUE_DISPUTE,
  SET_DASHER_ID,
  MARK_DELIVERY_ISSUE_AS_READ,
  SUBMIT_FAST_PAY_SETUP,
  UPDATE_VEHICLE,
  GET_SALES,
  VEHICLE_OPTOUT,
  UPDATE_PHONE_NUMBER,
  FORWARD_PAYMENT_ACCOUNT,
  COMPLETE_SAFETY_COURSE,
  UPDATE_IDV_STATUS,
  BANK_ACCOUNT_SKIP,
  GET_IDV_SESSION_TOKEN,
  LOAD_DASHER_SERIALIZER,
  LOAD_STARTING_POINT_STATUS,
} = makeAsyncActions('DX', [
  'SUBMIT_DASHER_APPLICATION',
  'FIND_DASHER_APPLICATION',
  'LOAD_DASHER_APPLICATION',
  'LOGIN_DASHER_APPLICATION',
  'LOAD_CONSUMER_APPLICATION',
  'CREATE_CONSUMER_ACCOUNT',
  'UPDATE_DASHER_APPLICANT',
  'SUBMIT_PERSONAL_INFO',
  'SUBMIT_BACKGROUND_CHECK',
  'CREATE_DASHER_ACCOUNT',
  'GO_TO_W9',
  'SUBMIT_MAILING_ADDRESS',
  'SET_DROPSHIPPING',
  'BOOK_ORIENTATION',
  'CLEAR_ORIENTATION',
  'LOAD_ORIENTATIONS',
  'GET_APPLICATION_STATUS',
  'ACTIVATE_REDCARD',
  'GET_STRIPE_CREDENTIALS',
  'GET_PAYMENT_ACCOUNT',
  'UPDATE_BANK_ACCOUNT',
  'CREATE_PAYMENT_ACCOUNT',
  'PATCH_PAYMENT_ACCOUNT',
  'UPLOAD_PHOTO',
  'GET_EXPERIMENT',
  'LOAD_WEBVIEW_EXPERIMENTS',
  'LOAD_DASHER',
  'LOAD_DASHER_ID',
  'LOAD_DASHER_REWARD',
  'LOAD_WEBVIEW_EXPERIENCE',
  'GET_DELIVERY_ISSUES_LIST',
  'GET_DELIVERY_ISSUE_DETAILS',
  'SUBMIT_DELIVERY_ISSUE_DISPUTE',
  'SET_DASHER_ID',
  'MARK_DELIVERY_ISSUE_AS_READ',
  'SUBMIT_FAST_PAY_SETUP',
  'UPDATE_VEHICLE',
  'GET_SALES',
  'VEHICLE_OPTOUT',
  'UPDATE_PHONE_NUMBER',
  'FORWARD_PAYMENT_ACCOUNT',
  'COMPLETE_SAFETY_COURSE',
  'UPDATE_IDV_STATUS',
  'BANK_ACCOUNT_SKIP',
  'GET_IDV_SESSION_TOKEN',
  'LOAD_DASHER_SERIALIZER',
  'LOAD_STARTING_POINT_STATUS',
])

export const dismissGuaranteedEarningsRedirectModal = createStandardAction(
  'DISMISS_GUARANTEED_EARNINGS_REDIRECT_MODAL'
)()

export const {
  NAVIGATE_TO_DASHER_APPLICATION,
  SUBMIT_PERSONAL_INFO_SUCCESS_NEED_LICENSE,
  SHOW_ERROR,
  CLEAR_ERRORS,
  SET_SUPPLY_ACQUISITION_METHOD,
  UPDATE_MAILING_ADDRESS,
  PICK_ORIENTATION_STARTING_POINT,
  TOGGLE_ALREADY_STARTED_SIGNING_UP_MODAL,
  CLEAR_DELIVERY_ISSUE_DISPUTE,
  SET_API_STATUS_CODE,
  SET_ONBOARDING_STEP,
} = makeActions('DX', [
  'NAVIGATE_TO_DASHER_APPLICATION',
  'SUBMIT_PERSONAL_INFO_SUCCESS_NEED_LICENSE',
  'SHOW_ERROR',
  'CLEAR_ERRORS',
  'SET_SUPPLY_ACQUISITION_METHOD',
  'UPDATE_MAILING_ADDRESS',
  'PICK_ORIENTATION_STARTING_POINT',
  'TOGGLE_ALREADY_STARTED_SIGNING_UP_MODAL',
  'CLEAR_DELIVERY_ISSUE_DISPUTE',
  'SET_API_STATUS_CODE',
  'SET_ONBOARDING_STEP',
])

export const GUARANTEED_EARNINGS_WRONG_ZIP = {
  CAMPAIGN_AVAILABLE: createStandardAction(
    'GUARANTEED_EARNINGS_WRONG_ZIP.CAMPAIGN_AVAILABLE'
  )(),
  CAMPAIGN_NOT_AVAILABLE: createStandardAction(
    'GUARANTEED_EARNINGS_WRONG_ZIP.CAMPAIGN_NOT_AVAILABLE'
  )(),
}

export const setApiStatusCode = (statusCode: number) => {
  let result

  // Axios sometimes gives us an undefined array here
  if (Array.isArray(statusCode)) {
    result = statusCode[0]
  } else {
    result = statusCode
  }

  return async dispatch => {
    dispatch({ type: SET_API_STATUS_CODE, payload: result || null })
  }
}

export const clearErrors = () => {
  return async dispatch => {
    dispatch({ type: CLEAR_ERRORS })
  }
}

export const getRedCard = dasherId => {
  return async dispatch => {
    return new Promise((resolve, reject) => {
      let counter = 0
      const poll = setInterval(async () => {
        try {
          const res = await api.getPurchaseCard(dasherId)
          clearInterval(poll)
          dispatch({ type: ACTIVATE_REDCARD.SUCCESS })
          resolve(res)
        } catch (error) {
          counter += 1
          if (counter > TIMEOUT_TRIES) {
            clearInterval(poll)
            dispatch({ type: ACTIVATE_REDCARD.FAIL, payload: error })
            dispatch({
              message:
                // tslint:disable-next-line:max-line-length
                'Couldn’t activate your Red Card. Check your details and try again.',
              type: SHOW_ERROR,
            })
            reject(error)
          }
        }
      }, REDCARD_POLL_INTERVAL)
    })
  }
}

export const activateRedCard = (dasherId, last4, delightNumber) => {
  return async dispatch => {
    dispatch({ type: ACTIVATE_REDCARD.IN_PROGRESS })
    disableHeader()
    try {
      await api.activatePurchaseCard(dasherId, last4, delightNumber)
      enableHeader()
    } catch (error) {
      dispatch({ type: ACTIVATE_REDCARD.FAIL, payload: error })
      dispatch({ error, type: SHOW_ERROR })
      enableHeader()
      throw error
    }
  }
}

export const submitDasherApplication = applicationData => {
  return async (dispatch, getState) => {
    dispatch({ type: SUBMIT_DASHER_APPLICATION.IN_PROGRESS })

    const { referred_by, source } = getUrlVars()
    const utmSource = getUtmSource()
    const referrerId = getState().referrer.id
    const referralCampaign = getState().referralCampaignId
    const signupCountryShortname = getState().signupCountryShortname

    const requestPayload = {
      ...applicationData,
      referralDomain: document.referrer || undefined,
      referredBy: referrerId || referred_by,
      source: source || utmSource,
      referralCampaign: referralCampaign || undefined,
      signupCountryShortname: signupCountryShortname || undefined,
    }

    try {
      // HACK: prevent dasher applications from being tied
      // to the currently logged in user when going to the
      // dasher application flow **when you've just signed up**
      //
      // See https://doordash.atlassian.net/browse/DX-2212
      // and https://github.com/doordash/doorstep-django/pull/5652
      SimpleStore.delete('token')
      SimpleStore.delete('ddweb_token')
      const data = await api.submitDasherApplication(requestPayload)
      dispatch({ type: SUBMIT_DASHER_APPLICATION.SUCCESS, payload: data })

      await identifyDasher(data)
      setUser({ id: data.uniqueLink })

      dispatch(
        trackDasherApplySubmissionSuccess({ ...data, ...requestPayload })
      )
      return data
    } catch (error) {
      if (get(error, 'fieldErrors.zipCode') === NON_MARKET_ERROR) {
        const { submarket } = getState().dasherApplyPageContent
        dispatch(
          trackDasherApplyNonMarket({
            submarket: submarket || '',
            zipCode: applicationData.zipCode,
          })
        )
      }

      dispatch(trackDasherApplySubmissionFailure)
      if (error.error) {
        dispatch(trackGESubmissionFailureInvalidZip(applicationData.zipCode))
        if (error.campaign) {
          // todo: rework this to use FSA Actions
          // (need to reshape reducers to match)
          dispatch({
            applicationData,
            type: 'GUARANTEED_EARNINGS_WRONG_ZIP.CAMPAIGN_AVAILABLE',
            campaign: error.campaign,
          })
        } else {
          dispatch({
            applicationData,
            type: 'GUARANTEED_EARNINGS_WRONG_ZIP.CAMPAIGN_NOT_AVAILABLE',
          })
        }
      } else {
        dispatch({ type: SUBMIT_DASHER_APPLICATION.FAIL, payload: error })
      }
      throw error
    }
  }
}

export const createConsumerAccount = args => {
  return async dispatch => {
    dispatch({ type: CREATE_CONSUMER_ACCOUNT.IN_PROGRESS })

    try {
      const response = await api.createConsumerAccount(args)
      dispatch({
        type: CREATE_CONSUMER_ACCOUNT.SUCCESS,
        payload: response.data,
      })
      dispatch(clearErrors)
    } catch (error) {
      dispatch(trackCreateConsumerAccountFailure())
      dispatch({ type: CREATE_CONSUMER_ACCOUNT.FAIL, payload: error.data })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const updateDasherApplicant = (uniqueLink, args) => {
  return async dispatch => {
    dispatch({ type: UPDATE_DASHER_APPLICANT.IN_PROGRESS })
    try {
      const response = await api.updateDasherApplicant(uniqueLink, args)
      dispatch({
        type: UPDATE_DASHER_APPLICANT.SUCCESS,
        payload: response.data,
      })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({ type: UPDATE_DASHER_APPLICANT.FAIL, payload: error.data })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(trackUpdateDasherApplicantFailure(error))
      throw error
    }
  }
}

export const submitPersonalInfo = (
  uniqueLink,
  args,
  application,
  isLoggedIn,
  vehicleTypes,
  offerLetterSigned,
  isIdentityMigration: boolean = false
) => {
  const { email, hasConsumerAccount, phoneNumberComponents } = application
  const phoneNumber = phoneNumberComponents.internationalNumber
  const addLicense =
    args.vehicleType && vehicleTypes[args.vehicleType].needs_license_info

  return async (dispatch, getState) => {
    const utmSource = getUtmSource()
    const consumerEmail = getState().consumerEmail
    dispatch({ type: SUBMIT_PERSONAL_INFO.IN_PROGRESS })
    try {
      if (!hasConsumerAccount) {
        // HACK: prevent dasher applications from being tied
        // to the currently logged in user when going to the
        // dasher application flow **when you've just signed up**
        //
        // See https://doordash.atlassian.net/browse/DX-2212
        // and https://github.com/doordash/doorstep-django/pull/5652
        SimpleStore.delete('token')
        SimpleStore.delete('ddweb_token')

        if (consumerEmail !== null && consumerEmail !== email) {
          try {
            await api.logout()
          } catch (e) {
            // tslint:disable-next-line:no-console
            console.warn(e)
          }
        }

        const consumerDetails = Object.assign({ email, phoneNumber }, args)
        await dispatch(createConsumerAccount(consumerDetails))
        await dispatch(
          updateDasherApplicant(uniqueLink, {
            ...args,
            utmSource,
            offerLetterSigned,
          })
        )
        await dispatch(
          login(email, args.password, uniqueLink, isIdentityMigration)
        )
      } else {
        await dispatch(
          updateDasherApplicant(uniqueLink, {
            ...args,
            utmSource,
            offerLetterSigned,
          })
        )
      }

      if (addLicense) {
        dispatch({
          type: SUBMIT_PERSONAL_INFO_SUCCESS_NEED_LICENSE,
        })
      }

      dispatch({ type: SUBMIT_PERSONAL_INFO.SUCCESS })
      dispatch(clearErrors)
    } catch (error) {
      if (isLoggedIn) {
        dispatch(trackSubmitProfileFailure(error))
      } else {
        dispatch(trackSignupAndSubmitProfileFailure(error))
      }

      dispatch({ type: SUBMIT_PERSONAL_INFO.FAIL, payload: error.data })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const findDasherApplication = applicationCredentials => {
  return async dispatch => {
    dispatch({ type: FIND_DASHER_APPLICATION.IN_PROGRESS })
    try {
      const data = await api.findDasherApplication(applicationCredentials)
      dispatch({ type: FIND_DASHER_APPLICATION.SUCCESS, payload: data })
      dispatch(clearErrors)
      dispatch(trackDasherReturnToApplicationSuccess())
      return data
    } catch (error) {
      dispatch({ type: FIND_DASHER_APPLICATION.FAIL, payload: error })
      dispatch(
        trackDasherReturnToApplicationFailure(error, applicationCredentials)
      )
      throw error
    }
  }
}

export const loadApplication = uniqueLink => {
  return async dispatch => {
    const utmSource = getUtmSource()
    dispatch({ type: LOAD_DASHER_APPLICATION.IN_PROGRESS })
    try {
      const response = await api.loadApplication(uniqueLink, utmSource)
      dispatch({
        type: LOAD_DASHER_APPLICATION.SUCCESS,
        payload: { uniqueLink, ...response },
      })
      dispatch(clearErrors)
    } catch (error) {
      // if status code is 401 we return an empty object otherwise we return false
      const payload = get(error, 'response.status') === 401 ? {} : false
      dispatch({ type: LOAD_DASHER_APPLICATION.FAIL, payload })
      if (!payload) {
        dispatch({ error, type: SHOW_ERROR })
      }
      dispatch(trackLoadDasherApplicationFailure(error))
      throw error
    }
  }
}

export const loadApplicationAndCreatePaymentAccount = (uniqueLink, data) => {
  return async dispatch => {
    const utmSource = getUtmSource()
    dispatch({ type: LOAD_DASHER_APPLICATION.IN_PROGRESS })
    try {
      const res = await api.loadApplication(uniqueLink, utmSource)
      const dob = res.dateOfBirth.split('-')

      // Personal identification number
      const pin = get(data, 'ssn', '')

      if (data) {
        const paymentPayload: Types.PaymentPayload = {
          target_id: res.dasherId,
          first_name: res.firstName,
          last_name: res.lastName,
          date_of_birth: {
            year: dob[0],
            month: dob[1],
            day: dob[2],
          },
          target_type: 'dasher',
          personal_identification_number: pin,
        }

        await dispatch(createPaymentAccount(paymentPayload))
      }
      await dispatch({ type: LOAD_DASHER_APPLICATION.SUCCESS, payload: res })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({ type: LOAD_DASHER_APPLICATION.FAIL, payload: error })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(trackLoadDasherApplicationFailure(error))
      throw error
    }
  }
}

export const loadApplicationWithPersona = uniqueLink => {
  return async dispatch => {
    const utmSource = getUtmSource()
    dispatch({ type: LOAD_DASHER_APPLICATION.IN_PROGRESS })
    try {
      const res = await api.loadApplication(uniqueLink, utmSource)
      if (res.identityVerificationStatus === IDVStatus.CREATED) {
        await dispatch(
          updateIdvStatus(uniqueLink, res.identityInquiryId, '', false)
        )
      }
      await dispatch({ type: LOAD_DASHER_APPLICATION.SUCCESS, payload: res })
      dispatch(clearErrors)
    } catch (error) {
      // if status code is 401 we return an empty object otherwise we return false
      const payload = get(error, 'response.status') === 401 ? {} : false
      dispatch({ type: LOAD_DASHER_APPLICATION.FAIL, payload })
      if (!payload) {
        dispatch({ error, type: SHOW_ERROR })
      }
      dispatch(trackLoadDasherApplicationFailure(error))
      throw error
    }
  }
}

export const closeInAppEducation = uniqueLink => {
  return dispatch => {
    try {
      api.closeInAppEducation(uniqueLink)
    } catch (error) {
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}

const dasherIdentify = uniqueLink => {
  try {
    return identifyDasher({ uniqueLink })
  } catch (_) {
    return false
  }
}

const getWebviewExperience = uniqueLink => {
  try {
    return api.getWebviewExperience(uniqueLink)
  } catch (_) {
    return false
  }
}

export const loadApplicationWebview = uniqueLink => {
  return dispatch => {
    dispatch({ type: LOAD_DASHER_APPLICATION.IN_PROGRESS })
    const loadApplicationPromise = api.loadApplication(uniqueLink)
    const getWebviewExperiencePromise = getWebviewExperience(uniqueLink)
    const dasherIdentifyPromise = dasherIdentify(uniqueLink)
    Promise.all([
      loadApplicationPromise,
      getWebviewExperiencePromise,
      dasherIdentifyPromise,
    ])
      .then(([data, experience]) => {
        setUser({ id: uniqueLink })
        dispatch({
          type: LOAD_WEBVIEW_EXPERIENCE.SUCCESS,
          payload: experience,
        })

        dispatch({
          type: LOAD_DASHER_APPLICATION.SUCCESS,
          payload: { uniqueLink, ...(data as Record<string, any>) },
        })

        dispatch(clearErrors)
      })
      .catch(error => {
        dispatch({
          type: SET_API_STATUS_CODE,
          payload: get(error, 'response.status', null),
        })

        const responseData = get(error, 'response.data')
        if (responseData) {
          dispatch({
            type: LOAD_DASHER_APPLICATION.FAIL,
            payload: responseData,
          })
          dispatch({ responseData, type: SHOW_ERROR })
          dispatch(trackLoadDasherApplicationFailure(responseData))
        }

        throw error
      })
  }
}

export const login = (
  email,
  password,
  uniqueLink,
  isIdentityMigration = false
) => {
  return async dispatch => {
    dispatch({ type: LOGIN_DASHER_APPLICATION.IN_PROGRESS })

    try {
      const response = await api.login(email, password)
      dispatch({
        type: LOGIN_DASHER_APPLICATION.SUCCESS,
        payload: { ...response.data, email },
      })

      // If NOT in Identity Service migration, then make call
      // to DSJ /v1/auth-token/ endpoint
      if (!isIdentityMigration) {
        const authTokenResponse = await api.authToken(email, password)
        SimpleStore.set('token', authTokenResponse.data.token)
      }

      await identifyDasher({ uniqueLink })
      setUser({ id: uniqueLink })
      if (
        typeof window.view.initialState === 'object' &&
        isEmpty(window.view.initialState)
      ) {
        window.location.reload(true)
      }

      dispatch(clearErrors)
      dispatch(loadApplication(uniqueLink))
      dispatch(getApplicationStatus(uniqueLink))
    } catch (error) {
      dispatch({ type: LOGIN_DASHER_APPLICATION.FAIL, payload: error })
      throw error
    }
  }
}

export const loadConsumer = () => {
  return async dispatch => {
    dispatch({ type: LOAD_CONSUMER_APPLICATION.IN_PROGRESS })
    try {
      const response = await api.loadConsumer()
      dispatch({
        type: LOAD_CONSUMER_APPLICATION.SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      // applicant is not logged in.
      SimpleStore.delete('token')
      SimpleStore.delete('ddweb_token')

      dispatch({ type: LOAD_CONSUMER_APPLICATION.FAIL, payload: error })
    }
  }
}
export const loadDasherSerializer = (fields?: string[]) => {
  return async dispatch => {
    dispatch({ type: LOAD_DASHER_SERIALIZER.IN_PROGRESS })
    try {
      const response = await api.loadDasher(fields)

      dispatch({
        type: LOAD_DASHER_SERIALIZER.SUCCESS,
        payload: camelCaseObjectKeys(response.data),
      })
    } catch (error) {
      dispatch({ type: LOAD_DASHER_SERIALIZER.FAIL, payload: error })
      throw error
    }
  }
}

export const loadDasher = () => {
  return async dispatch => {
    dispatch({ type: LOAD_DASHER.IN_PROGRESS })
    try {
      const response = await api.loadDasher()
      dispatch({ type: LOAD_DASHER.SUCCESS, payload: response.data })
    } catch (error) {
      dispatch({ type: LOAD_DASHER.FAIL, payload: error })
      throw error
    }
  }
}

export const loadDasherId = () => {
  return async dispatch => {
    dispatch({ type: LOAD_DASHER_ID.IN_PROGRESS })
    try {
      const response = await api.loadDasherId()
      dispatch({ type: LOAD_DASHER_ID.SUCCESS, payload: response.data })
    } catch (error) {
      dispatch({ type: LOAD_DASHER_ID.FAIL, payload: error })
    }
  }
}
export const loadStartingPointStatus = () => {
  return async dispatch => {
    dispatch({ type: LOAD_STARTING_POINT_STATUS.IN_PROGRESS })
    try {
      const response = await api.getStartingPointStatus()
      dispatch({
        type: LOAD_STARTING_POINT_STATUS.SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      dispatch({ type: LOAD_STARTING_POINT_STATUS.FAIL, payload: error })
    }
  }
}

/**
 * Given a users dasherId set it to the redux store
 * @param dasherId
 */
export const setDasherId = dasherId => {
  return dispatch => {
    if (dasherId) {
      return dispatch({
        type: SET_DASHER_ID.SUCCESS,
        payload: { id: dasherId },
      })
    }
    return dispatch({ type: SET_DASHER_ID.FAIL })
  }
}

export const setOnboardingStep = step => {
  return dispatch =>
    dispatch({
      type: SET_ONBOARDING_STEP,
      payload: step || null,
    })
}

// tslint:disable-next-line:max-line-length
export const submitBackgroundCheck = (uniqueLink, args) => {
  return async dispatch => {
    dispatch({ type: SUBMIT_BACKGROUND_CHECK.IN_PROGRESS })

    try {
      const data = await api.submitBackgroundCheck(uniqueLink, args)
      dispatch({
        type: SUBMIT_BACKGROUND_CHECK.SUCCESS,
        payload: data,
      })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({
        type: SUBMIT_BACKGROUND_CHECK.FAIL,
        payload: error,
      })
      dispatch(trackSubmitBackgroundCheckError(error))
      dispatch({ message: t.submissionError(), type: SHOW_ERROR })
      throw error
    }
  }
}

// tslint:disable-next-line:max-line-length
export const submitBackgroundCheckTokenized = (uniqueLink, args, form) => {
  return async dispatch => {
    dispatch({ type: SUBMIT_BACKGROUND_CHECK.IN_PROGRESS })

    try {
      const data = await api.submitBackgroundCheckTokenized(
        uniqueLink,
        args,
        form
      )
      dispatch({
        type: SUBMIT_BACKGROUND_CHECK.SUCCESS,
        payload: data,
      })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({
        type: SUBMIT_BACKGROUND_CHECK.FAIL,
        payload: error,
      })
      dispatch({ type: SHOW_ERROR })
      dispatch(trackSubmitBackgroundCheckError(error))
      throw error
    }
  }
}

export const createDasherAccount = uniqueLink => {
  return async dispatch => {
    dispatch({ type: CREATE_DASHER_ACCOUNT.IN_PROGRESS })

    try {
      const response = await api.createDasherAccount(uniqueLink)

      dispatch({
        type: CREATE_DASHER_ACCOUNT.SUCCESS,
        payload: response.data,
      })

      dispatch(clearErrors)
    } catch (error) {
      dispatch({
        type: CREATE_DASHER_ACCOUNT.FAIL,
        payload: error,
      })
      dispatch(trackCreateDasherAccountError(error))
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const goToW9Signing = uniqueLink => {
  return async dispatch => {
    dispatch({ type: GO_TO_W9.IN_PROGRESS })
    dispatch(trackDropshippingEvent('DA_dxds_w9_go_to_docusign'))

    try {
      const url = await api.goToW9Signing(uniqueLink)
      dispatch({ type: GO_TO_W9.SUCCESS })
      dispatch(clearErrors)
      // maybe change this to use a step
      window.location.href = url
    } catch (error) {
      dispatch({ type: GO_TO_W9.FAIL })
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}

export const setDropshipping = (uniqueLink, value) => {
  return async dispatch => {
    dispatch({ type: SET_DROPSHIPPING.IN_PROGRESS })
    try {
      await api.setDropshipping(uniqueLink, value)
      dispatch({ type: SET_DROPSHIPPING.SUCCESS, payload: true })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({ type: SET_DROPSHIPPING.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const setSupplyAcquisitionMethod = method => ({
  method,
  type: SET_SUPPLY_ACQUISITION_METHOD,
})

export const submitMailingAddress = (
  uniqueLink,
  mailingAddress,
  application
) => {
  return async dispatch => {
    dispatch({ type: SUBMIT_MAILING_ADDRESS.IN_PROGRESS })

    try {
      await api.submitMailingAddress(uniqueLink, mailingAddress)
      dispatch({ type: SUBMIT_MAILING_ADDRESS.SUCCESS })
      if (
        get(application, 'country', 'US') === 'CA' &&
        get(application, 'needsBgCheckInfo', false)
      ) {
        dispatch(submitBackgroundCheck(uniqueLink, { copy_requested: false }))
      }
      dispatch(clearErrors)
    } catch (error) {
      dispatch({
        type: SUBMIT_MAILING_ADDRESS.FAIL,
        payload: error.fieldErrors && error.fieldErrors.mailingAddress,
      })
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}

export const updateMailingAddress = newMailingAddressData => ({
  type: UPDATE_MAILING_ADDRESS,
  payload: newMailingAddressData,
})

export const bookOrientation = (uniqueLink, orientationId, application) => {
  return async dispatch => {
    dispatch({ type: BOOK_ORIENTATION.IN_PROGRESS })

    try {
      const response = await api.bookOrientation(uniqueLink, orientationId)
      dispatch({ type: BOOK_ORIENTATION.SUCCESS, payload: response })

      if (
        get(application, 'country', 'US') === 'CA' &&
        get(application, 'needsBgCheckInfo', false)
      ) {
        dispatch(submitBackgroundCheck(uniqueLink, { copy_requested: false }))
      }
      dispatch(clearErrors)
    } catch (error) {
      dispatch(trackOrientationBookingError(error))
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}

export const loadOrientations = uniqueLink => {
  return async dispatch => {
    dispatch({ type: LOAD_ORIENTATIONS.IN_PROGRESS })
    try {
      const response = await api.loadOrientations(uniqueLink)

      dispatch({ type: LOAD_ORIENTATIONS.SUCCESS, payload: response })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({ type: LOAD_ORIENTATIONS.FAIL })
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}

export const clearOrientation = uniqueLink => {
  return async dispatch => {
    dispatch({ type: CLEAR_ORIENTATION.IN_PROGRESS })

    try {
      await api.clearOrientation(uniqueLink)
      dispatch({ type: CLEAR_ORIENTATION.SUCCESS })
      dispatch(clearErrors)
    } catch (error) {
      dispatch({ type: CLEAR_ORIENTATION.FAIL, payload: error.data })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(trackOrientationBookingError(error.data))
    }
  }
}

export const pickOrientationStartingPoint = sp => {
  return {
    type: PICK_ORIENTATION_STARTING_POINT,
    startingPoint: sp,
  }
}

export const getApplicationStatus = uniqueLink => {
  return async dispatch => {
    dispatch({ type: GET_APPLICATION_STATUS.IN_PROGRESS })

    try {
      const response = await api.getApplicationStatus(uniqueLink)

      dispatch({
        type: GET_APPLICATION_STATUS.SUCCESS,
        payload: response.data,
      })
      dispatch(clearErrors)
      return response
    } catch (error) {
      dispatch({
        type: SET_API_STATUS_CODE,
        payload: get(error, 'response.status', null),
      })
      dispatch({ type: GET_APPLICATION_STATUS.FAIL })
    }
  }
}
export const getStripeCredentials = dasherId => {
  return async dispatch => {
    try {
      const response = await api.getStripeCredentials(dasherId)
      dispatch({
        type: GET_STRIPE_CREDENTIALS.SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      dispatch({
        type: SET_API_STATUS_CODE,
        payload: get(error, 'response.status', null),
      })
      dispatch({ type: GET_STRIPE_CREDENTIALS.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Error,
          name: DA.PaymentAccountNames.GetStripeCredentials,
          message: error.message,
        })
      )
    }
  }
}

export const createPaymentAccount = data => {
  return async dispatch => {
    dispatch({ type: CREATE_PAYMENT_ACCOUNT.IN_PROGRESS })
    try {
      const response = await api.createPaymentAccount(data)
      dispatch({
        type: CREATE_PAYMENT_ACCOUNT.SUCCESS,
        payload: response.data,
      })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Success,
          name: DA.PaymentAccountNames.CreatePaymentAccount,
        })
      )
    } catch (error) {
      dispatch({ type: CREATE_PAYMENT_ACCOUNT.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Error,
          name: DA.PaymentAccountNames.CreatePaymentAccount,
          message: error.message,
        })
      )
      throw error
    }
  }
}
export const getPaymentAccount = dasherId => {
  return async (dispatch, getState) => {
    try {
      // fetches the payment accountId from dasher object
      // then calls payments endpoint for stripe details
      let paymentAccountId = await api.getPaymentAccountId(dasherId)

      if (!paymentAccountId) {
        // if payment account id returns null - explicitely
        // calling create payment account

        const paymentPayload = {
          ...processStatePayloadForStripe(getState()),
          target_type: 'dasher',
        }
        const paymentAccount = await api.createPaymentAccount(paymentPayload)
        paymentAccountId = paymentAccount.data.id
      }
      const response = await api.getPaymentAccount(paymentAccountId)

      dispatch({
        type: GET_PAYMENT_ACCOUNT.SUCCESS,
        payload: response,
      })
    } catch (error) {
      dispatch({ type: GET_PAYMENT_ACCOUNT.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Error,
          name: DA.PaymentAccountNames.GetPaymentAccountId,
          message: error.message,
        })
      )
      throw error
    }
  }
}

export const forwardPaymentAccount = paymentData => {
  return async (dispatch, getState) => {
    const state = getState()

    // These dispatch here are currently noops - leaving them currently
    // as placeholders incase we want to handle the status in the future
    dispatch({
      type: FORWARD_PAYMENT_ACCOUNT.IN_PROGRESS,
    })
    try {
      await api.updateDasherApplicant(state.application.uniqueLink, {
        bankAccountToken: paymentData,
      })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Success,
          name: DA.PaymentAccountNames.ForwardPaymentAccount,
        })
      )
      dispatch({
        type: FORWARD_PAYMENT_ACCOUNT.SUCCESS,
      })
    } catch (e) {
      dispatch({
        type: FORWARD_PAYMENT_ACCOUNT.FAIL,
      })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Error,
          name: DA.PaymentAccountNames.ForwardPaymentAccount,
          message: e.message,
        })
      )
    }
  }
}

export const updateBankAccount = (paymentAccountId, token) => {
  return async dispatch => {
    dispatch({
      type: UPDATE_BANK_ACCOUNT.IN_PROGRESS,
    })
    try {
      const response = await api.updateBankAccount(paymentAccountId, token)
      dispatch({
        type: UPDATE_BANK_ACCOUNT.SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      dispatch({ type: UPDATE_BANK_ACCOUNT.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Error,
          name: DA.PaymentAccountNames.UpdateBankAccount,
          message: error.message,
        })
      )
      throw error
    }
  }
}

/**
 * @param data.token bank account token
 */
export const createBankAccount = data => {
  return async (dispatch, getState) => {
    const state = getState()
    if (state.paymentAccount && state.paymentAccount.stripeAccountId !== null) {
      await dispatch(updateBankAccount(state.paymentAccount.id, data.token))
      // multiplexing bank data to third party via dasher applicant
      if (data.isW2Dasher) {
        await dispatch(forwardPaymentAccount(data.paymentData))
      }
      return
    }

    // Dasher has no payment account so need to create one,
    // fetch the account that was attached to the dasher
    // then patch it
    const paymentPayload = {
      ...processStatePayloadForStripe(getState()),
      target_type: 'dasher',
    }
    const response = await api.createPaymentAccount(paymentPayload)
    await dispatch(updateBankAccount(response.data.id, data.token))
    // copy pasting this here as part of this combo call to keep
    // updateBankAccount as a clean primary payment service call
    // and using that as a source of validation.

    if (data.isW2Dasher) {
      await dispatch(forwardPaymentAccount(data.paymentData))
    }
  }
}

export const updatePaymentAccount = (paymentAccountId, data) => {
  return async dispatch => {
    dispatch({
      type: PATCH_PAYMENT_ACCOUNT.IN_PROGRESS,
    })
    try {
      const response = await api.updatePaymentAccount(paymentAccountId, data)
      dispatch({
        type: PATCH_PAYMENT_ACCOUNT.SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      dispatch({ type: PATCH_PAYMENT_ACCOUNT.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackPaymentAccount({
          action: DA.EventActions.Error,
          name: DA.PaymentAccountNames.UpdatePaymentAccount,
          message: error.message,
        })
      )
      throw error
    }
  }
}

/**
 *
 * @param stripeKey Stripe public key
 * @param paymentAccountId Payment account ID for Dasher
 * @param payload Image data to upload to Stripe
 * @param side Front or Back photo identificaiton
 */
export const uploadPhoto = (
  stripeKey: string,
  paymentAccountId: string,
  payload: object,
  side: string = 'front'
) => {
  return async dispatch => {
    try {
      const response = await api.uploadFileToStripe(stripeKey, payload)
      const data = {}
      const key = side.toLowerCase() === 'back' ? 'id_back_file' : 'id_file'
      data[key] = response.id

      const patch = await api.updatePaymentAccount(paymentAccountId, data)
      dispatch({
        type: UPLOAD_PHOTO.SUCCESS,
        payload: { ...response, ...patch },
      })
    } catch (error) {
      dispatch({ type: UPLOAD_PHOTO.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const getExperiment = name => {
  return async dispatch => {
    try {
      dispatch({ type: GET_EXPERIMENT.IN_PROGRESS })

      const response = await api.getExperiment(name)
      const payload = {
        data: response.data,
      }
      dispatch({ payload, type: GET_EXPERIMENT.SUCCESS })
    } catch (error) {
      dispatch({ type: GET_EXPERIMENT.FAIL })
      dispatch({ error, type: SHOW_ERROR })

      // todo: add stat
      throw error
    }
  }
}

export const toggleAlreadyStartedSigningUpModal = (
  payload: AlreadyStartedSigningUpModal
) => {
  return async dispatch => {
    dispatch({ payload, type: TOGGLE_ALREADY_STARTED_SIGNING_UP_MODAL })
  }
}

export const getDeliveryIssuesList = (dasherId: string) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_DELIVERY_ISSUES_LIST.IN_PROGRESS })

      const response = await api.getDeliveryIssuesList(dasherId)

      const deliveryIssuesWithoutId = response.filter(issue => issue.id == null)

      if (deliveryIssuesWithoutId.length > 0) {
        dispatch(trackDeliveryIssuesWithoutId(deliveryIssuesWithoutId))
      }

      dispatch({
        payload: response,
        type: GET_DELIVERY_ISSUES_LIST.SUCCESS,
      })
    } catch (error) {
      dispatch(trackGetDeliveryIssuesListError(error))
      dispatch({ payload: error, type: GET_DELIVERY_ISSUES_LIST.FAIL })
    }
  }
}

/**
 * Fetches the details of a delivery issue. Then if the issue status is
 * "unread", continue to mark the issue as read.
 */
export const getDeliveryIssueDetails = (dasherId: string, issueId: string) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_DELIVERY_ISSUE_DETAILS.IN_PROGRESS })
      const response = await api.getDeliveryIssueDetails(dasherId, issueId)
      dispatch({ payload: response, type: GET_DELIVERY_ISSUE_DETAILS.SUCCESS })

      if (response.status === DeliveryIssueStatus.Unread) {
        dispatch(markDeliveryIssueAsRead(dasherId, issueId))
      }
    } catch (error) {
      dispatch({ payload: error, type: GET_DELIVERY_ISSUE_DETAILS.FAIL })
    }
  }
}

/**
 * action creator to submit a users dispute for a given delivery issue
 */
export const submitDeliveryIssueDispute = (
  dasherId: string,
  issueId: string,
  message: string
) => {
  return async dispatch => {
    try {
      dispatch({ type: SUBMIT_DELIVERY_ISSUE_DISPUTE.IN_PROGRESS })
      await api.submitDeliveryIssueDispute(dasherId, issueId, message)
      dispatch({ type: SUBMIT_DELIVERY_ISSUE_DISPUTE.SUCCESS })
    } catch (error) {
      dispatch({ type: SUBMIT_DELIVERY_ISSUE_DISPUTE.FAIL, payload: error })
    }
  }
}

export const clearDeliveryIssueDispute = () => {
  return async dispatch => {
    dispatch({ type: CLEAR_DELIVERY_ISSUE_DISPUTE })
  }
}

export const markDeliveryIssueAsRead = (dasherId: string, issueId: string) => {
  return async dispatch => {
    try {
      dispatch({ type: MARK_DELIVERY_ISSUE_AS_READ.IN_PROGRESS })
      const response = await api.markDeliveryIssueAsRead(dasherId, issueId)
      dispatch({ payload: response, type: MARK_DELIVERY_ISSUE_AS_READ.SUCCESS })
    } catch (error) {
      dispatch({ payload: error, type: MARK_DELIVERY_ISSUE_AS_READ.FAIL })
    }
  }
}

export const submitFastPaySetup = (
  dasherId: string,
  stripeToken: string,
  mfaEnable: boolean = false
) => {
  return async dispatch => {
    try {
      dispatch({ type: SUBMIT_FAST_PAY_SETUP.IN_PROGRESS })
      const response = await api.submitFastPaySetup(
        dasherId,
        stripeToken,
        mfaEnable
      )
      dispatch({ payload: response, type: SUBMIT_FAST_PAY_SETUP.SUCCESS })
      dispatch(
        trackFastPaySetup({
          action: DA.EventActions.Success,
          name: DA.FastPayNames.AddDebitCard,
        })
      )
    } catch (error) {
      const errorResponse = get(error, 'error')
      dispatch({ payload: errorResponse, type: SUBMIT_FAST_PAY_SETUP.FAIL })
      dispatch(
        trackFastPaySetup({
          action: DA.EventActions.Error,
          name: DA.FastPayNames.AddDebitCard,
          value: errorResponse,
        })
      )
      throw errorResponse
    }
  }
}

export const updateVehicle = (vehicleId: number, data: VehiclePatchData) => {
  return async dispatch => {
    try {
      dispatch(clearErrors)
      dispatch({ type: UPDATE_VEHICLE.IN_PROGRESS })
      await api.updateVehicle(vehicleId, data)
      dispatch({ type: UPDATE_VEHICLE.SUCCESS })
    } catch (e) {
      dispatch({ type: UPDATE_VEHICLE.FAIL })
      dispatch({ e, type: SHOW_ERROR })
    }
  }
}

export const getSales = (uniqueLink, phone) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_SALES.IN_PROGRESS })
      const result = await api.postGetSales(uniqueLink, phone)
      const payload = { phone, timestamp: Date.now(), wait: result.data.wait }
      dispatch({ payload, type: GET_SALES.SUCCESS })
    } catch (error) {
      dispatch({ type: GET_SALES.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const vehicleOptOut = (uniqueLink: string) => {
  return async dispatch => {
    try {
      dispatch(clearErrors)
      dispatch({ type: VEHICLE_OPTOUT.IN_PROGRESS })
      await api.vehicleOptOut(uniqueLink)
      dispatch({ type: VEHICLE_OPTOUT.SUCCESS })
    } catch (e) {
      dispatch({ type: VEHICLE_OPTOUT.FAIL })
      dispatch({ e, type: SHOW_ERROR })
    }
  }
}

export const updatePhoneNumber = (
  formattedPhoneNumber: string,
  deviceId: string
) => {
  return async dispatch => {
    try {
      dispatch(clearErrors)
      dispatch({ type: UPDATE_PHONE_NUMBER.IN_PROGRESS })
      await api.updateDasherPhoneNumber(formattedPhoneNumber, deviceId)
      dispatch({ type: UPDATE_PHONE_NUMBER.SUCCESS })
    } catch (error) {
      dispatch({ type: UPDATE_PHONE_NUMBER.FAIL })
      if (get(error, 'code') !== 401) {
        dispatch({ error, type: SHOW_ERROR })
      }
      throw error
    }
  }
}

export const markSafetyCourseComplete = (uniqueLink: string) => {
  return async dispatch => {
    try {
      dispatch(clearErrors)
      dispatch({ type: COMPLETE_SAFETY_COURSE.IN_PROGRESS })
      await api.markSafetyCourseComplete(uniqueLink)
      dispatch({ type: COMPLETE_SAFETY_COURSE.SUCCESS })
    } catch (error) {
      dispatch({ type: COMPLETE_SAFETY_COURSE.FAIL })
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}
export const markBankAccountSkip = () => {
  return async dispatch => {
    try {
      dispatch(clearErrors)
      dispatch({ type: BANK_ACCOUNT_SKIP.IN_PROGRESS })
      await api.markBankAccountSkip()
      dispatch({ type: BANK_ACCOUNT_SKIP.SUCCESS })
    } catch (error) {
      dispatch({ type: BANK_ACCOUNT_SKIP.FAIL })
      dispatch({ error, type: SHOW_ERROR })
    }
  }
}

export const updateIdvStatus = (
  uniqueLink: string,
  inquiryId: string,
  eventType: string,
  polling: boolean
) => {
  return async dispatch => {
    try {
      dispatch({ type: UPDATE_IDV_STATUS.IN_PROGRESS })
      const response = await api.submitIdv(
        uniqueLink,
        inquiryId,
        eventType,
        polling
      )
      dispatch({
        payload: camelCaseObjectKeys(response.data).idvStatus,
        type: UPDATE_IDV_STATUS.SUCCESS,
      })
    } catch (error) {
      dispatch({ type: UPDATE_IDV_STATUS.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}

export const getIdvSessionToken = (uniqueLink: string, inquiryId: string) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_IDV_SESSION_TOKEN.IN_PROGRESS })
      const response = await api.getIdvSessionToken(uniqueLink, inquiryId)
      dispatch({
        payload: camelCaseObjectKeys(response.data).sessionToken,
        type: GET_IDV_SESSION_TOKEN.SUCCESS,
      })
    } catch (error) {
      dispatch({ type: GET_IDV_SESSION_TOKEN.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}
